import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {  MODAL_DISPLAY_OPTIONS } from '../../constants'
import { openModal } from '../../actions/modal'
import { closePopover } from '../../actions/popover'
import PopoverLayout from './popover_layout'
import List from '../list'

class SidebarMorePopover extends React.PureComponent {

  handleOnOpenDisplayModal = () => {
    this.props.onOpenDisplayModal()
  }

  handleOnClosePopover = () => {
    this.props.onClosePopover()
  }

  render() {
    const { isXS } = this.props

    if (isXS) return null

    return (
      <PopoverLayout width={240}>
        <List
          size='large'
          scrollKey='profile_options'
          items={[
            {
              title: 'Help',
              href: 'https://help.gab.com',
            },
            {
              title: 'Gab Deck',
              to: '/deck',
              onClick: this.handleOnClosePopover,
            },
            {
              title: 'Display Options',
              onClick: this.handleOnOpenDisplayModal,
            },
            {
              title: 'Blocked users',
              to: '/settings/blocks',
            },
            {
              title: 'Muted users',
              to: '/settings/mutes',
            },
            {
              title: 'Settings',
              href: '/settings/preferences',
            },
            {
              title: 'Log out',
              href: '/auth/sign_out',
            },
          ]}
        />
      </PopoverLayout>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  onClosePopover() {
    dispatch(closePopover())
  },
  onOpenDisplayModal: () => {
    dispatch(closePopover())
    dispatch(openModal(MODAL_DISPLAY_OPTIONS))
  },
})

SidebarMorePopover.propTypes = {
  onOpenDisplayModal: PropTypes.func.isRequired,
  isXS: PropTypes.bool,
}

export default connect(null, mapDispatchToProps)(SidebarMorePopover)